import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { apiClient } from '@cast/infrastructure-api';
import type { RestrictionSilence } from '@cast/types';

import { getClusterRestrictionsQueryKey } from 'hooks/queries/cluster-restrictions/useClusterRestrictionsQuery';
import { getRestrictionDetailsQueryKey } from 'hooks/queries/cluster-restrictions/useRestrictionDetailsQuery';
import { getRestrictionSilencesQueryKey } from 'hooks/queries/restriction-silences/useRestrictionSilencesQuery';

const apiFn = apiClient.costReport.createRestrictionSilence;

type CreateRestrictionSilenceParams = Parameters<typeof apiFn>[0];

export const useCreateRestrictionSilenceMutation = (): UseMutationResult<
  AxiosResponse<RestrictionSilence>,
  AxiosError,
  CreateRestrictionSilenceParams
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: apiFn,
    onSuccess: (_data, { clusterId }) => {
      void queryClient.invalidateQueries({
        queryKey: getRestrictionSilencesQueryKey({ clusterId }),
      });
      // Silences hide matching restrictions from the restrictions APIs
      void queryClient.invalidateQueries({
        queryKey: getClusterRestrictionsQueryKey(),
      });
      void queryClient.invalidateQueries({
        queryKey: getRestrictionDetailsQueryKey(),
      });
    },
  });
};
